/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Space } from "./Space";
export const SpaceResponse = core.serialization.object({
    data: Space,
});
